import { FC, useRef, useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Box,
  Button,
  Alert,
  AlertTitle,
  // TextField,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import InputField from "src/components/ui-components/InputField";
import useIsMountedRef from "../../../hooks/useIsMountedRef";
import useAuth from "../../../hooks/useAuth";
import { Visibility, VisibilityOff } from "@material-ui/icons";

interface UserSignInProps {
  setUsername: (username: string) => void;
}

export const UserSignIn: FC<UserSignInProps> = ({ setUsername }) => {
  const { login } = useAuth() as any;
  const ref = useRef(null);
  const isMountedRef = useIsMountedRef();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      ref.current.handleSubmit();
    }
  };

  return (
    <Formik
      innerRef={ref}
      initialValues={{
        username: "",
        password: "",
        submit: null,
      }}
      validationSchema={Yup.object().shape({
        username: Yup.string().max(255).required("User Name is required"),
        password: Yup.string().max(255).required("Password is required"),
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting }
      ): Promise<void> => {
        try {
          await login(values.username, values.password);
        } catch (err) {
          if (isMountedRef.current) {
            setStatus({ success: false });
            setErrors({
              submit: err.errors?.[0].errorMessage || err.title || err.message,
            });
            setSubmitting(false);
          }
        }
      }}
    >
      {({ errors, handleSubmit, isSubmitting, handleChange }): JSX.Element => (
        <form noValidate onSubmit={handleSubmit} autoComplete="off">
          <InputField
            name="username"
            label="User Name"
            margin="normal"
            onChange={(e) => {
              handleChange(e);
              setUsername(e.target.value);
            }}
            autoFocus
          />
          <InputField
            name="password"
            label="Password"
            margin="normal"
            onKeyUp={handleKeyUp}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setShowPassword((prev) => !prev);
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {errors.submit && (
            <Box sx={{ mt: 1 }}>
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {errors.submit}
              </Alert>
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <Button
              sx={{
                background: "linear-gradient(to bottom, #072f40, #072f40)",
              }}
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              Log In
              {isSubmitting && (
                <CircularProgress
                  color="primary"
                  thickness={5}
                  size={20}
                  sx={{ ml: 1 }}
                />
              )}
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default UserSignIn;
